import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Tooltip,
  Legend,
} from "recharts";
import { ChartData } from "./types";

interface DataPieChartProps {
  data: ChartData;
}

export default function DataPieChart({ data }: DataPieChartProps) {
  const nameKey = data.columns[0];
  const dataKey = data.columns[1] ?? data.columns[0];

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={data.rows as Record<string, unknown>[]}
          dataKey={dataKey}
          nameKey={nameKey}
          cx="50%"
          cy="50%"
          outerRadius={100}
        />
        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
}
